// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import { processEntityOutput as processEntityOutputPhoneNumber } from 'store/app/common/phone-number';

export const processEntityInput = (values) => ({ ...values, ...processEntityInputMain(values) });

export const processEntityOutput = (values) => ({
    ...values,

    ...processEntityOutputMain(values),

    id: undefined,

    isBeingAdded: undefined,

    isBeingEdited: undefined,

    isBeingDeleted: undefined,

    phoneNumbers:
        'phoneNumbers' in (values || {}) && Array.isArray(values.phoneNumbers)
            ? values.phoneNumbers.map((phoneNumber) => processEntityOutputPhoneNumber(phoneNumber))
            : undefined
});
